import { render, staticRenderFns } from "./ProductDescriptionDialog.vue?vue&type=template&id=5ff35e15"
import script from "./ProductDescriptionDialog.vue?vue&type=script&lang=js"
export * from "./ProductDescriptionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports